import React from "react";
import {
  BudgetModalBody,
  BudgetModalHeader,
  BudgetModalFooter,
  BudgetModalWrapper,
  BudgetModalContent,
  BudgetModalCloseButton,
} from "./BudgetExtractorModal.styles";

const BudgetExtractorModal: React.FC<{
  open: boolean;
  onClose: () => void;
  header: string | React.ReactNode;
  footer: React.ReactNode;
  hideCloseIcon?: boolean;
  children: React.ReactNode;
}> = ({ open, onClose, header, children, footer, hideCloseIcon = false }) => {
  return (
    <BudgetModalWrapper $open={open}>
      <BudgetModalContent className="modal">
        <BudgetModalHeader className="modal-header">
          {typeof header === "string" ? <h1>{header}</h1> : header}
          {!hideCloseIcon && (
            <BudgetModalCloseButton aria-label="close-button" onClick={onClose}>
              &times;
            </BudgetModalCloseButton>
          )}
        </BudgetModalHeader>
        <BudgetModalBody className="modal-body">{children}</BudgetModalBody>
        {footer && <BudgetModalFooter className="modal-footer">{footer}</BudgetModalFooter>}
      </BudgetModalContent>
    </BudgetModalWrapper>
  );
};

export default BudgetExtractorModal;
